// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (width >= 750px) {
    #user-account-page .content {
        padding: 0 30px;
    }
}
@media (width < 750px) {
    #user-account-page .content {
        padding: 0 30px;
        box-sizing: border-box;
        margin: 0 auto;
    }
}
`, "",{"version":3,"sources":["webpack://./client/pages/users/UserAccountPage.css"],"names":[],"mappings":"AAAA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;QACf,sBAAsB;QACtB,cAAc;IAClB;AACJ","sourcesContent":["@media (width >= 750px) {\n    #user-account-page .content {\n        padding: 0 30px;\n    }\n}\n@media (width < 750px) {\n    #user-account-page .content {\n        padding: 0 30px;\n        box-sizing: border-box;\n        margin: 0 auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
